import { headerOverlapSelector, headerVisibilitySelector } from "@client/widgets/Header/selectors";
import classnames from "classnames";
import { createSelector } from "reselect";

export const classNameSelector = createSelector(
  [headerVisibilitySelector, headerOverlapSelector],
  (visibility, overlap) =>
    classnames({
      "header-overlap": visibility.isVisible && overlap
    })
);
